export const getFromStorage = (key: string, storage = 'localStorage'): any | undefined => {
  if (typeof localStorage === 'undefined') {
    return
  }

  try {
    return storage === 'localStorage' ? localStorage.getItem(key) : sessionStorage.getItem(key)
  } catch (error) {
    console.error(error)
    return
  }
}

export const saveToStorage = (key: string, value: any, storage = 'localStorage'): void => {
  try {
    const serializedValue = JSON.stringify(value)
    storage === 'localStorage'
      ? localStorage.setItem(key, serializedValue)
      : sessionStorage.setItem(key, serializedValue)
  } catch (error) {
    console.error(error)
  }
}

export const removeFromStorage = (key: string, storage = 'localStorage'): void => {
  try {
    storage === 'localStorage' ? localStorage.removeItem(key) : sessionStorage.removeItem(key)
  } catch (error) {
    console.error(error)
  }
}
